<template>
  <div class="book">
    <BodyBook />
  </div>
</template>

<script>
// @ is an alias to /src
import BodyBook from "@/components/BodyBook.vue";

export default {
  name: "Book",
  components: {
    BodyBook,
  },
};
</script>
